export default __webpack_public_path__ + "static/media/v2play.8d95a759.png";